export const IMG_URL = "http://127.0.0.1:4342";
// export const IMG_URL = "https://hindustansolarnode.profcymadev.com:1518";

export const Select2Data = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};
export const formatPrice = (price) => {
  const amount = Number(price);

  if (amount >= 10000000) {
    return `₹${(amount / 10000000).toFixed(2)} Cr`;
  }

  if (amount >= 100000) {
    return `₹${(amount / 100000).toFixed(2)} Lakh`;
  }

  return `₹${amount.toLocaleString("en-IN")}`;
};

export const FixIDS = {
  Role: { List: 1, Add: 2, Update: 3, Delete: 4 },
  Country: { List: 5, Add: 6, Update: 7, Delete: 8 },
  State: { List: 9, Add: 10, Update: 11, Delete: 12 },
  District: { List: 13, Add: 14, Update: 15, Delete: 16 },
  Taluka: { List: 17, Add: 18, Update: 19, Delete: 20 },
  Area: { List: 21, Add: 22, Update: 23, Delete: 24 },
  Purpose: { List: 25, Add: 26, Update: 27, Delete: 28 },
  Category: { List: 29, Add: 30, Update: 31, Delete: 32 },
  Property_Type: { List: 33, Add: 34, Update: 35, Delete: 36 },
  Furnish_Type: { List: 37, Add: 38, Update: 39, Delete: 40 },
  BHK_Type: { List: 41, Add: 42, Update: 43, Delete: 44 },
  Facing: { List: 45, Add: 46, Update: 47, Delete: 48 },
  Availability: { List: 49, Add: 50, Update: 51, Delete: 52 },
  Key_Highlights: { List: 53, Add: 54, Update: 55, Delete: 56 },
  Possession: { List: 57, Add: 58, Update: 59, Delete: 60 },
  Amenities: { List: 61, Add: 62, Update: 63, Delete: 64 },
  SubscriptionValidity: { List: 65, Add: 66, Update: 67, Delete: 68 },
  SubscriptionFeatures: { List: 69, Add: 70, Update: 71, Delete: 72 },
  Subscription: { List: 73, Add: 74, Update: 75, Delete: 76 },
  Users: { List: 77, Add: 78, Update: 79, Delete: 80 },
  Work_Start: { List: 81, Add: 82, Update: 83, Delete: 84 },
  GetProperty: { List: 85 },
  Expert_Enquiry: { List: 86 },
  App_Setup: { List: 87, Update: 88 },
  Contact_Us: { List: 89 },
  About_Us_Detail: { List: 90, Add: 91, Update: 92, Delete: 93 },
  Our_Story: { List: 94, Add: 95, Update: 96, Delete: 97 },
  Why_Choose_Us: { List: 98, Add: 99, Update: 100, Delete: 101 },
  Our_Platform_Work: { List: 102, Add: 103, Update: 104, Delete: 105 },
  Our_Users_Say: { List: 106, Add: 107, Update: 108, Delete: 109 },
  Privacy_and_Policy: { List: 110, Add: 111, Update: 112, Delete: 113 },
  Terms_and_Conditions: { List: 114, Add: 115, Update: 116, Delete: 117 },
  Social_Link: { List: 118, Add: 119, Update: 120, Delete: 121 },
  GetPropertyInquiry: { List: 122 },
  GetRating: { List: 123 },
  Leads: { List: 124 },
  RentalProperty: { List: 125, Add: 126, Update: 127, Delete: 128 },
  GetRentalProperty: { List: 129 },
  Area_In: { List: 130, Add: 131, Update: 132, Delete: 133 },
  Parking: { List: 134, Add: 135, Update: 136, Delete: 137 },
  City: { List: 138, Add: 139, Update: 140, Delete: 141 },
  Pincode: { List: 142, Add: 143, Update: 144, Delete: 145 },
};
